import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'reason',
        'deleteSubmitContainer',
        'deleteSuccessContainer',
        'validationError',
    ];

    deleteProfile(event) {
        if (this.reasonTarget.value === '') {
            this.validationErrorTarget.classList.remove('d-none');
            return;
        }

        event.preventDefault();

        dataLayer.push({
            event: 'dataLayer.gaEvent', gaEvent: {
                'action': 'delete_profile_submit', 'category': 'Account',
            },
        });

        this.deleteSubmitContainerTarget.classList.add('d-none');
        this.deleteSuccessContainerTarget.classList.remove('d-none');

        $.post(routes['app_profile_deleteprofile'], {
            reason: this.reasonTarget.value,
        });

        setTimeout(() => {
            window.location.reload();
        }, 10000);
    }

    validate(event) {
        if (this.reasonTarget.value === '') {
            this.validationErrorTarget.classList.remove('d-none');
        } else {
            this.validationErrorTarget.classList.add('d-none');
        }
    }
}
